"use strict";
var Observable_1 = require("../../Observable");
var combineLatest_1 = require("../../operator/combineLatest");
Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/combineLatest.js
 ** module id = 275
 ** module chunks = 1
 **/